import './style.css';
import moment from 'moment';
import { DatePicker } from 'antd';
import React, { useEffect, useState } from 'react';
//import { truncate } from 'lodash';
const { RangePicker, MonthPicker, WeekPicker } = DatePicker;

const SelectionComponent = (props) => {
 
const [,setPayload] = useState({});
const [selectionWidget,setSelectionWidget] = useState(props.selectionWidget || {});
const [mode,setMode] = useState(['month', 'month']);
const [isOpen,setIsOpen] = useState(false);
const [monthValue,setMonthValue] = useState(moment());
const [year,setYear] = useState(moment());
const [week,setWeek] = useState(moment().startOf('week'));
const [dateRangeValue,setDateRangeValue] = useState({
  startDate: moment().subtract('30', 'days').utc().format('YYYY-MM-DD HH:mm:ss'),
  endDate: moment().utc().format('YYYY-MM-DD HH:mm:ss')
});
const [selectedRange,setSelectedRange] = useState(null);
const [,setRangePickerOpen] = useState(null);

useEffect(() => {
  setSelectionWidget(props.selectionWidget);
  setMonthValue(moment());
},[props.selectionWidget]);


 const onYearPicker = (year) => {

    if (selectionWidget.payload) {
      let payload = {};
      Object.keys(selectionWidget.payload).map((payloadParams, key) => {
        if (key <= 1 && key === 0) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment(year)
            .startOf('year')
            .utc()
            .format(payloadItem.format);
        } else if (key <= 1 && key === 1) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment(year)
            .endOf('years')
            .utc()
            .format(payloadItem.format);
        }
        if (payloadParams === 'year') {
          payload[`${payloadParams}`] = moment(year).utc().format('YYYY');
        }
        return {};
      });
      setPayload(payload);
      props.selectionpayload(payload);
    }
  };

  const onDataPickerChange = (value, dateString) => {
  
    if (selectionWidget.payload) {
      let payload = {};
      Object.keys(selectionWidget.payload).map((payloadParams) => {
        let payloadItem = selectionWidget.payload[payloadParams];
        if (selectionWidget.payload[payloadParams].add) {
          let { value, key } = selectionWidget.payload[payloadParams].add;
          payload[`${payloadParams}`] = moment(dateString)
            .utc()
            .add(value, key)
            .format(`${payloadItem.format}`);
        } else if (selectionWidget.payload[payloadParams].subtract) {
          let { value, key } = selectionWidget.payload[payloadParams].add;
          payload[`${payloadParams}`] = moment(dateString)
            .utc()
            .subtract(value, key)
            .format(`${payloadItem.format}`);
        } else {
          payload['startDate'] = moment(dateString)
            .startOf('day')
            .utc()
            .format(`${payloadItem.format}`);
          payload['endDate'] = moment(dateString)
            .endOf('day')
            .utc()
            .format(`${payloadItem.format}`);
          // payload[`${payloadParams}`] = moment(dateString).format(payloadItem.format);
        }

        if (payloadParams === 'Date') {
          payload[`${payloadParams}`] = moment(dateString).utc().format('YYYY-MM-DD');
        }
        return {};
      });
      setPayload(payload);
      props.selectionpayload(payload);
     

    }
  };

  const onOk = (dateString) => {
   
    if (selectionWidget.payload) {
      let payload = {};
      Object.keys(selectionWidget.payload).map((payloadParams, key) => {
        if (key <= 1) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment(dateString[key]).format(payloadItem.format);
        }
        return {};
      });
      setPayload(payload);
    }
  };

  const onMonthPickerChange = (dateString) => {
   
    let month = moment(dateString).month();
    let year = moment(dateString).year();

    if (selectionWidget.payload) {
      let payload = {};
      Object.keys(selectionWidget.payload).map((payloadParams, key) => {
        if (key <= 1 && key === 0) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment([year, month])
            .startOf('month')
            .utc()
            .format(payloadItem.format);
        } else if (key <= 1 && key === 1) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment([year, month])
            .endOf('months')
            .utc()
            .format(payloadItem.format);
        }
        if (payloadParams === 'month') {
          payload[`${payloadParams}`] = moment(dateString).utc().format('MMMM');
        }
        if (payloadParams === 'year') {
          payload[`${payloadParams}`] = year;
        }
        return {};
      });
      setPayload(payload);
      setMonthValue(dateString);
      props.selectionpayload(payload);
    }
  };

  const onWeakChange = (value) => {
    let startDate = moment(value).startOf('week').utc().format('YYYY-MM-DD HH:mm:ss');
    let endDate = moment(value).endOf('week').utc().format('YYYY-MM-DD HH:mm:ss');

    setPayload({
      startDate,
      endDate
    });
    setWeek(value);
    props.selectionpayload({ startDate, endDate });
  };

  const onRangePickerChange = (dateString, dateString1) => {
    let startDate =
      dateString1 && dateString1[0]
        ? moment(dateString1[0]).utc().format('YYYY-MM-DD HH:mm:ss')
        : '';
    let endDate =
      dateString1 && dateString1[1]
        ? moment(dateString1[1]).utc().format('YYYY-MM-DD HH:mm:ss')
        : '';

    setPayload({
      startDate,
      endDate
    });
    setDateRangeValue(dateString1);
    props.selectionpayload({ startDate, endDate });
  };

  const onCalendarChange = (selectedRange) => {
    setSelectedRange(selectedRange);
  };

  const handlePanelChange = (dateString, mode) => {

    let startMonth = moment(dateString[0]).month();
    let startYear = moment(dateString[0]).year();
    let endMonth = moment(dateString[1]).month();
    let endYear = moment(dateString[1]).year();

    if (selectionWidget.payload) {
      let payload = {};
      Object.keys(selectionWidget.payload).map((payloadParams, key) => {
        if (key <= 1 && key === 0) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment([startYear, startMonth])
            .startOf('month')
            .format(payloadItem.format);
        } else if (key <= 1 && key === 1) {
          let payloadItem = selectionWidget.payload[payloadParams];
          payload[`${payloadParams}`] = moment([endYear, endMonth])
            .add('months', 1)
            .format(payloadItem.format);
        }
        return {};
      });
      setPayload(payload);
      setMode( [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]);
    } else {
      setMode( [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]]);
    }
  };

 const disabledDate = (current) => {
    return current > moment().endOf('day');
  };

 const disabledRangeDate = (current, selectedRange) => {
    if (selectedRange) {
      return (
        current > moment(selectedRange[0]).add('31', 'day') ||
        current < moment(selectedRange[0]) ||
        current > moment().endOf('day')
      );
    } else {
      return current > moment().endOf('day');
    }
  };


    let { displayWidget, widget, displayDateFormat, displayTimeFormat, placeholder, format } =
      selectionWidget;

    let dateFormat = 'YYYY-MM-DD';
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row-reverse',
          justifyContent: 'space-between',
          marginBottom: '15px'
        }}
      >
        {displayWidget && widget === 'date-picker' ? (
          <DatePicker
            onChange={onDataPickerChange}
            defaultValue={moment().subtract('day', 1)}
            placeholder={placeholder}
            disabledDate={disabledDate}
          />
        ) : null}
        {displayWidget && widget === 'dateRange-picker' ? (
          <RangePicker
            showTime={{ format: displayTimeFormat }}
            format={displayDateFormat}
            placeholder={placeholder}
            onChange={onRangePickerChange}
            onCalendarChange={onCalendarChange}
            onOk={onOk}
            defaultValue={[
              moment(dateRangeValue.startDate, dateFormat),
              moment(dateRangeValue.endDate, dateFormat)
            ]}
            // format={dateFormat}
            disabledDate={(current) => disabledRangeDate(current, selectedRange)}
            onOpenChange={(rangePickerOpen) => {
              setRangePickerOpen(rangePickerOpen);
              setSelectedRange(undefined);
            }}
            ranges={{
              'Reset Filter': [moment().subtract('30', 'days'), moment()]
            }}
          />
        ) : null}
        {displayWidget && widget === 'month-picker' ? (
          <MonthPicker
            className="picker"
            placeholder="Select month"
            value={monthValue}
            format={format}
            disabledDate={disabledDate}
            onChange={onMonthPickerChange}
          />
        ) : null}
        {displayWidget && widget === 'monthRange-picker' ? (
          <RangePicker
            placeholder={placeholder}
            format={format}
            mode={mode}
            //   onChange={this.onMonthRangePickerChange}
            onPanelChange={handlePanelChange}
          />
        ) : null}
        {displayWidget && widget === 'year-picker' ? (
          <DatePicker
            value={year}
            open={isOpen}
            mode="year"
            placeholder="Select Year"
            format="YYYY"
            onOpenChange={(status) => {
              if (status) {
                setIsOpen(true);
              } else {
                setIsOpen(false);
              }
            }}
            onPanelChange={(v) => {
              this.setState({ isOpen: false, year: v });
              setIsOpen(false);
              setYear(v);
              onYearPicker(v);
            }}
          // onChange={this.onYearPicker}
          />
        ) : null}
        {displayWidget && widget === 'weak-picker' ? (
          <WeekPicker
            defaultValue={week}
            style={{ width: '200px' }}
            disabledDate={disabledDate}
            placeholder={placeholder}
            allowClear={false}
            onChange={onWeakChange}
          />
        ) : null}
      </div>
    );
  };


export default SelectionComponent;
